const state = {
    purchaseReconciliation:[],
    typeChangeState: [],
    loading: false,
};

export default state;